module.exports = __webpack_public_path__ + "img/voucher-validate02.81c39d79.png";